const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

module.exports = function getSectionByLetter(planner, i, short) {
	return short ? `${letters[i]}.` : `Section ${letters[i]}`;
};
